import { isNumber } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import useOrganisationGroupName from '../../../data/hooks/useOrganisationGroupName';
import organisationStructureTreeSelector from '../../../data/organisationStructureTreeSelector.graphql';
import nodeSortingOptionsSequence from '../../../utils/nodeSortingOptionsSequence';

import {
  adapter,
  selectionFilter,
} from '../../containers/EntityForm/fields/OrganisationsTreeSelectorField';
import useT from '../../utils/Translations/useT';

import GqlStaticTreeSelector from './GqlStaticTreeSelector';

import useResetOnDeps from './hooks/useResetOnDeps';
import { isRootNode } from '../../dataViews/DynamicTree';
import Button from '../Button';

const OrganisationsTreeSelector = ({
  orgGroupId,
  disabled,
  onChange,
  selectionFilter: selectionFilterProps,
  title,
  plugins = {},
  ...rest
}) => {
  const t = useT();
  const orgGroupName = useOrganisationGroupName(orgGroupId);

  useResetOnDeps({ orgGroupId }, onChange, []);

  const renderNodeAddons = (node, meta) => {
    const { handleClear } = meta;

    const handleClearFn = e => {
      handleClear();
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    };

    const addons = [];
    if (isRootNode(node)) {
      addons.push(
        <Button
          additionClasses="text-primary no-padding-top no-padding-bottom"
          buttonStyle="link"
          onClick={handleClearFn}
        >
          {t('Clear')}
        </Button>,
      );
    }

    return addons;
  };

  return (
    <GqlStaticTreeSelector
      hasSyntheticRootNode
      adapter={{ ...adapter, renderNodeAddons }}
      disabled={!isNumber(orgGroupId) || disabled}
      gql={organisationStructureTreeSelector}
      gqlSkip={!isNumber(orgGroupId)}
      gqlVariables={{ orgGroupId }}
      hasClearButton={false}
      plugins={{
        nodeSortingOptions: nodeSortingOptionsSequence,
        ...plugins,
      }}
      selectionFilter={selectionFilterProps || selectionFilter}
      syntheticRootNodeName={orgGroupName}
      title={t(title)}
      onChange={onChange}
      {...rest}
    />
  );
};

OrganisationsTreeSelector.propTypes = {
  title: PropTypes.string,
  orgGroupId: PropTypes.number,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  selectionFilterProps: PropTypes.func,
};

OrganisationsTreeSelector.defaultProps = {
  title: 'Organisations',
  orgGroupId: null,
  required: true,
  disabled: false,
  onChange: null,
  selectionFilterProps: null,
};

export default OrganisationsTreeSelector;
